import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef, useMemo } from "react";
import ErrorMessage from "./ErrorMessage";
import { usePreventContextMenu } from "@/hooks";

const TextField = forwardRef((props, ref) => {
  const {
    error,
    className,
    title,
    caption,
    required,
    placeholder,
    defaultValue,
    textSecurity = false,
    allowChanged,
    forbidChange,
    ..._props
  } = props;

  const [on, off] = usePreventContextMenu();

  const defaultValueProps = useMemo(() => {
    const _defaultValue = (() => {
      if (_props?.value) return null;
      if (defaultValue) return defaultValue;
      return "";
    })();
    const props = {};
    if (_defaultValue) {
      props.defaultValue = _defaultValue;
    }
    return props;
  }, [_props?.value, defaultValue]);

  return (
    <div className={styles.inputField}>
      {title && (
        <legend
          className={classnames(styles.formTitle, {
            [styles.required]: required,
            [styles.allowChanged]: allowChanged,
            [styles.forbidChange]: forbidChange,
          })}
        >
          {title}
        </legend>
      )}
      <input
        ref={ref}
        type="text"
        placeholder={placeholder}
        className={classnames(styles.textInput, className, {
          [styles.textSecurity]: textSecurity,
        })}
        required={required}
        onFocus={off}
        onBlur={on}
        {..._props}
        {...defaultValueProps}
      />
      {error && <ErrorMessage msg={error} />}
      {caption && <p className={styles.textInputCaption}>{caption}</p>}
    </div>
  );
});
TextField.displayName = "TextField";
export default TextField;
